<template>
  <div class="fluid-container">
    <div class="col-md-6 p-0 m-0">
      <Info v-show="$globalData.SelectedMenu == 0" :data="$globalData.data" />
      <Kalendar
        v-show="$globalData.SelectedMenu == 2"
        :data="$globalData.data"
      />
      <Profile
        v-show="$globalData.SelectedMenu == 1"
        :data="$globalData.data"
      />
      <Aktivitas
        v-show="$globalData.SelectedMenu == 3"
        :data="$globalData.data"
      />
      <Nilai v-show="$globalData.SelectedMenu == 4" :data="$globalData.data" />
      <Izin
        v-show="$globalData.SelectedMenu == 5"
        :data="$globalData.datauser"
      />
    </div>
  </div>
</template>

<script>
// import Profile from "../views/profile";
// import Info from "../views/info";
// import Upload from "../views/upload";
// import Kartu from "../views/kartu";
// import Ortu from "../views/ortu";

import Info from "@/myview/info.vue";
import Kalendar from "@/myview/kalendar.vue";
import Aktivitas from "@/myview/aktivitas.vue";
import Nilai from "@/myview/nilailine.vue";
import Izin from "@/myview/izin.vue";
import Profile from "@/myview/profile.vue";

// import axios from "axios";

export default {
  name: "Menu",

  components: {
    Info,
    Kalendar,
    Aktivitas,
    Nilai,
    Izin,
    Profile,
  },
  data() {
    return {
      para: this.$route.params.id,
    };
  },
  // mounted() {
  mounted: async function () {
    const isAuthenticated = localStorage.getItem("authToken");
    if (this.para != isAuthenticated) {
      this.$router.push({ path: "/" });
      console.log("NOtvalid");
    } else {
      this.$globalData.TokenOK = 1;

      //  $globalData.UserId
      this.$globalData.UserId = localStorage.getItem("userid");
      this.$globalData.pasfoto = localStorage.getItem("pasfoto");
      this.$globalData.Token = localStorage.getItem("Token");
      this.$globalData.data = JSON.parse(localStorage.getItem("data"));
      this.$globalData.datauser = JSON.parse(localStorage.getItem("datauser"));
      this.$globalData.LoginOK = localStorage.getItem("LoginOK");
      // let tkn = localStorage.getItem('psbtoken')
      console.log("userid", this.$globalData.UserId);
    }
  },
  methods: {},
};
</script>
